import { cn } from "src/lib/utils";
import WidgetLoading from "../WidgetLoading";

const LoadingContainer = ({className,isLoading, isError, loadingText="Loading data...", errorText="Error loading data", children, hasData, title, noDataText="No Data Available", small=false}) => {
    return ( 
        //An error occurred while fetching setup details, please close this popup and try again
        <>
            {isLoading && <LoadingTemplate small={small} title={title} message={small?"":loadingText} icon={"ri-loader-4-line animate-spin text-[40px] text-vekin"}  className={className} />}
            {isError && !isLoading &&  <LoadingTemplate small={small} title={title} message={errorText} icon={"ri-alert-fill"} className={className} />}
            {!isLoading && !isError && !hasData &&  <LoadingTemplate small={small} title={title} message={noDataText} icon={"ri-error-warning-line"} className={className}/> }
            {!isLoading && !isError && hasData && children}
        </>
     );
}
 
export default LoadingContainer;

const LoadingTemplate =({title, message, icon, children, small, className})=>{
    return(
        <div className={cn("flex flex-col h-full gap-6 p-4 bg-white",className)}>
            <div className="">
                {children}
                <span className="widget-title">{title}</span>
               {!small && <hr className="mt-2"></hr> }
            </div>
            <div className="relative flex flex-col items-center justify-center h-[80%] text-tertiary">

                <div className={small?"absolute -top-14 flex items-center flex-col":"flex flex-col items-center"}>
                <i className={`${(small)?"text-[30px]":"text-[60px]"} ${icon}`}></i>
                <p className="-mt-3 widget-status">{message}</p>    
                </div>
            </div>
        </div>
    )
}